const generateUUID = () => {
  // valid UUIDv4
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, match => {
    let random = Math.trunc(Math.random() * 16);
    return match === 'x' ? random.toString(16) : ((random & 3) | 8).toString(16);
  });
};

export default generateUUID;
